import React, { lazy } from 'react'
import { MdTableRows } from 'react-icons/md';
import lazyComponent from './lazy'
import LogsComponent from 'containers/Logs';


const Component: React.FC = () => <div>Testing</div>

const Logs = [
  {
    key: 'view_Logs',
    url: 'logs',
    name: 'App.Logs',
    roles: ['IMOX'],
    title: 'Logs',
    views: {
      'main@App': { component: lazyComponent(LogsComponent) }
    },
    data: {
      nav: {
        type: 'menu',
        sort: Number.MAX_SAFE_INTEGER,
        icon: <MdTableRows />,
        roles: []
      }
    }
  }
]

export default Logs
